module.exports = __webpack_public_path__ + "static/media/AoA_Map_BG-sm.9083727a.jpg";